<script setup lang="ts">
import { CHATS_DEFAULT_PAGE_NUMBER_ON_LOAD } from '@/config/config.ts'
import { useTranslations } from '@/composables/useTranslations.ts'
const { t } = useTranslations()

const { totalPages, currentPage } = defineProps({
  totalPages: {
    type: Number,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
    default: CHATS_DEFAULT_PAGE_NUMBER_ON_LOAD,
  },
})

const emit = defineEmits(['changePage'])

function goToPage(page: number) {
  if (page >= 1 && page <= totalPages) {
    emit('changePage', page)
  }
}
</script>

<template>
  <div class="flex items-center justify-center space-x-2 px-3">
    <button
      @click="goToPage(currentPage - 1)"
      :disabled="currentPage === 1"
      class="px-2 py-2 bg-indigo-200 text-indigo-700 rounded-md hover:bg-gray-300 disabled:opacity-50"
    >
      {{ t('common.pagePagination.previous') }}
    </button>
    <span class="text-sm text-gray-600 text-center">
      {{ t('common.pagePagination.page') }} {{ currentPage }}
      {{ t('common.pagePagination.of') }} {{ totalPages }}</span
    >
    <button
      @click="goToPage(currentPage + 1)"
      :disabled="currentPage === totalPages"
      class="px-4 py-2 bg-indigo-200 text-indigo-700 rounded-md hover:bg-gray-300 disabled:opacity-50"
    >
      {{ t('common.pagePagination.next') }}
    </button>
  </div>
</template>
